import { NavIconName } from '../useNavigationItems'

import { ReactComponent as CalendarHeartIcon } from '@percent/workplace-giving/assets/icons/nav/calendar-heart.svg'
import { ReactComponent as FlashIcon } from '@percent/workplace-giving/assets/icons/nav/flash.svg'
import { ReactComponent as HeartIcon } from '@percent/workplace-giving/assets/icons/nav/heart.svg'
import { ReactComponent as HomeIcon } from '@percent/workplace-giving/assets/icons/nav/home.svg'

const NAV_ICONS: Record<NavIconName, typeof HomeIcon> = {
  home: HomeIcon,
  heart: HeartIcon,
  'calendar-heart': CalendarHeartIcon,
  flash: FlashIcon
}

/**
 * Mobile nav glyphs. These are WPG-specific and deliberately not in Lemonade's
 * IconRegistry — they take their colour from `currentColor`, so the active
 * state is set on the parent.
 */
export function NavIcon({ name }: Readonly<{ name: NavIconName }>) {
  const Glyph = NAV_ICONS[name]

  return <Glyph />
}
